import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPage.css';

const SelezionePersonale = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <div className="header-section">
          <Link to="/" className="back-link">← Torna alla Home</Link>
          <div className="logo-section">
            <img src="/com-service-logo.png" alt="COM Service Logo" className="logo" />
          </div>
        </div>

        <div className="document-content">
          <h2>Informativa sul trattamento dei dati personali dei candidati</h2>
          
          <div className="content-section">
            <p>
              Ai sensi degli artt. 13 del D. lgs. 196/03 (nel seguito "Codice") e artt. 13 e 14 del Regolamento 2016/679/UE (nel
              seguito "GDPR") COM Service S.c.a.r.l (nel seguito "Titolare") con sede in Via Isonzo 6 – 22078 Turate (CO), nella
              sua veste di "Titolare del trattamento", La informa che i Suoi dati personali raccolti ai fini della selezione del
              personale per COM Service S.c.a.r.l (quale dipendente, collaboratore, stageur, apprendista, etc.) saranno trattati
              nel pieno rispetto della normativa applicabile, garantendo i diritti e le libertà fondamentali che Le sono riconosciuti.
            </p>
          </div>

          <div className="content-section">
            <h3>Origine e tipologia dei dati trattati</h3>
            <p>
              Il trattamento dei Suoi dati personali che di massima sono da Lei direttamente forniti (via e-mail, in formato
              cartaceo, compilando l'apposito form sul sito aziendale, etc), ma possono anche provenire da Soggetti terzi ai quali è
              stata affidata l'attività di selezione (Società di head-hunting, siti specializzati nella selezione del personale, etc.) è
              effettuato da parte di COM Service S.c.a.r.l per la selezione dei potenziali candidati con i qual instaurare un
              rapporto di collaborazione nelle forme e con le modalità di volta in volta individuate, nel rispetto degli obblighi
              derivanti da norme di legge eventualmente applicabile. Tale trattamento ha ad oggetto:
            </p>
            <ul>
              <li>
                <strong>a)</strong> i dati anagrafici, i dati di contatto,i dati relativi ai percorsi formativi effettuati (titolo di studio, corsi di
                formazione, etc.);
              </li>
              <li>
                <strong>b)</strong> i dati relativi alle esperienze professionali pregresse, alla conoscenza di lingue estere, nonché ogni
                ulteriore informazione utile alla valutazione del suo CV incluso i livelli retributivi,, etc.;
              </li>
              <li>
                <strong>c)</strong> dati provenienti da fonti pubbliche quali siti internet, social network (ai dati contenuti nel suo profilo
                pubblico di Facebook / Linkedin, etc.), giornali e riviste anche specialistiche, pubblicazioni scientifiche
                od altri documenti o scritti a carattere divulgativo pubblicati o comunque consultabili liberamente,
                siti specializzati nel favorire l'incontro tra la domanda e l'offerta di lavoro.
              </li>
            </ul>
            <p>
              Tra i suddetti dati, possono essere presenti anche i dati che la vigente normativa considera come "particolari" (dati
              sensibili), ovvero dati relativi a condanne penali e reati (dati giudiziari).
            </p>
            <p>
              I dati particolari/sensibili sono (ex art. 4. C. 1 lett. d) del Codice e art. 9 c. 1 del Regolamento), ad esempio, quelli
              idonei a rivelare lo stato di salute, di maternità, infortuni, inabilità, l'adesione ad un partito politico o ad un
              sindacato, la convinzione religiosa, uno stato di disabilità. Nel caso di candidatura spontanea gli eventuali dati
              particolari/sensibili saranno trattati ai sensi dell'art. 24 c1 lett. i) bis senza la necessità dello specifico consenso.
            </p>
          </div>

          <div className="content-section">
            <h3>Base giuridica e finalità del trattamento</h3>
            <p>
              I Suoi dati personali, richiesti o acquisiti sia preventivamente che nel corso delle attività di selezione, saranno trattati
              dal Titolare per le seguenti finalità:
            </p>
            <ul>
              <li>
                <strong>a)</strong> gestire la valutazione del suo Cv;
              </li>
              <li>
                <strong>b)</strong> programmare e gestire il/i colloquio/i di selezione anche in modalità interattiva o di gruppo;
              </li>
              <li>
                <strong>c)</strong> proporre la sua candidatura ad altre società facenti parte di COM Service S.c.a.r.l.
              </li>
            </ul>
            <p>
              Tali dati sono trattati ai sensi dell'art. 24 c. 1 lett. b) del Codice e art. 6 c.1 b) del Regolamento, anche quando
              sensibili, per dare corso alle attività di valutazione della sua candidatura, per valutare le sue competenze e capacità
              rispetto alle esigenze di COM Service S.c.a.r.l.
            </p>
            <p>
              Saranno adottati inoltre tutti i criteri previsti dal D. lgs. 125/91 a garanzia di non-discriminazione tra i sessi in sede di
              selezione.
            </p>
          </div>

          <div className="content-section">
            <h3>Comunicazione e diffusione</h3>
            <p>
              I suoi dati possono essere comunicati a soggetti terzi quali società esterne di propria fiducia operanti, a titolo
              esemplificativo, nel settore della selezione del personale, nelle attività di assessment delle competenze e,
              ricorrendone l'esigenza a strutture operanti nel settore sanitario di cui COM Service S.c.a.r.l si avvale, per ragioni di
              natura tecnica e organizzativa, per la gestione della Sua candidatura; professionisti esterni e società collegate e/o
              controllate da COM Service S.c.a.r.l, nonché società, consorzi e/o altre entità giuridiche nelle quali COM Service
              S.c.a.r.l partecipi in qualità di socio; società di COM Service S.c.a.r.l interessate ad instaurare con Lei un rapporto di
              lavoro. Tali soggetti, società e professionisti tratteranno i Suoi dati in qualità di autonomi titolari o, quando
              necessario, di responsabili del trattamento debitamente nominati da parte di COM Service S.c.a.r.l.
            </p>
            <p>
              Inoltre, in ragione del ruolo di coordinamento e direzione svolto da COM Service S.c.a.r.l, i Suoi dati potranno
              essere trattati, nell'ambito della normale attività di gestione della selezione del personale, ovvero da singoli
              dipendenti delle stesse, per le necessarie attività organizzative, amministrative, finanziarie e contabili che possono
              essere svolte da ciascuna di tali società in favore delle altre.
            </p>
            <p>
              Resta fermo l'obbligo per il Titolare di comunicare i dati alle Autorità competenti, su specifica richiesta delle stesse.
            </p>
          </div>

          <div className="content-section">
            <h3>Trasferimento all'estero</h3>
            <p>
              I Suoi dati non sono, di norma,trasferiti al di fuori dello Spazio Economico Europeo; qualora ciò risulti necessario per
              la gestione delle attività di selezione, ai soggetti destinatari dei dati saranno imposti obblighi di protezione e
              sicurezza equivalenti a quelli garantiti dal Titolare. In ogni caso, saranno comunicati i soli dati necessari al
              perseguimento degli scopi previsti e saranno applicate, ove richiesto, le garanzie applicabili ai trasferimenti di dati
              verso paesi terzi.
            </p>
          </div>

          <div className="content-section">
            <h3>Modalità del trattamento e tempi di conservazione</h3>
            <p>
              I Suoi dati sono raccolti e registrati in modo lecito e secondo correttezza, per il perseguimento delle finalità sopra
              indicate e nel rispetto dei principi fondamentali stabiliti dalla normativa applicabile.
            </p>
            <p>
              Il trattamento dei dati personali può avvenire sia mediante strumenti manuali, che informatici e telematici, ma
              sempre sotto il presidio di misure tecniche e organizzative idonee a garantirne la sicurezza e la riservatezza,
              soprattutto al fine di ridurre i rischi di distruzione o perdita, anche accidentale, dei dati, di accesso non autorizzato, o
              di trattamento non consentito o non conforme alle finalità della raccolta.
            </p>
            <p>
              I dati personali verranno trattati da COM Service S.c.a.r.l per tutta la durata delle attività di selezione: nel caso di
              candidatura spontanea i dati verranno conservati per12 mesi decorsi i quali saranno cancellati; nel caso di risposta
              da una selezione avviata da COM Service S.c.a.r.l i termini di conservazione sono quelli indicati nel prospetto e
              comunque non eccederanno i 24 dalla chiusura della selezione; in ogni caso Lei potrà richiedere che il suo CV venga
              conservato per eventuali successive esigenze che dovessero presentarsi in COM Service S.c.a.r.l.
            </p>
          </div>

          <div className="content-section">
            <h3>Natura del conferimento e consenso al trattamento</h3>
            <p>
              Come sopra indicato, il conferimento dei Suoi dati ha natura obbligatoria, essendo necessario al perseguimento
              delle finalità di cui al punto 1. lett. a) e b) connesse alla selezione del personale. E' invece facoltativo il conferimento
              dei suoi dati personali per le finalità di cui al punto 1. lett. c) per il quale Lei può decidere liberamente se prestare lo
              specifico consenso che potrà sempre revocare. Nel caso il suo Cv contenga dati particolari/sensibili il loro
              trattamento è subordinato al consenso che dovrà essere rilasciato in forma scritta.
            </p>
          </div>

          <div className="content-section">
            <h3>I Suoi Diritti</h3>
            <p>
              Potrà esercitare in ogni momento i diritti che Le sono riconosciuti dalla legge, tra cui quello:
            </p>
            <ul>
              <li>
                <strong>a)</strong> di accedere ai Suoi dati personali, ottenendo evidenza delle finalità perseguite da parte del Titolare,
                delle categorie di dati coinvolti, dei destinatari a cui gli stessi possono essere comunicati, del periodo
                di conservazione applicabile, dell'esistenza di processi decisionali automatizzati;
              </li>
              <li>
                <strong>b)</strong> di ottenere senza ritardo la rettifica dei dati personali inesatti che La riguardano;
              </li>
              <li>
                <strong>c)</strong> di ottenere, nei casi previsti, la cancellazione dei Suoi dati;
              </li>
              <li>
                <strong>d)</strong> di ottenere la limitazione del trattamento o di opporsi allo stesso, quando possibile;
              </li>
              <li>
                <strong>e)</strong> di richiedere la portabilità dei dati che Lei ha fornito a COM Service S.c.a.r.l, vale a dire di riceverli in
                un formato strutturato, di uso comune e leggibile da dispositivo automatico, anche per trasmettere
                tali dati ad un altro titolare, senza alcun impedimento da parte di COM Service S.c.a.r.l stessa;
              </li>
              <li>
                <strong>f)</strong> di proporre reclamo all'Autorità Garante per la Protezione dei Dati Personali.
              </li>
            </ul>
            <p>
              Se intende richiedere ulteriori informazioni sul trattamento dei Suoi dati personali o per l'eventuale esercizio dei
              Suoi diritti, potrà rivolgersi per iscritto a COM Service S.c.a.r.l .
            </p>
          </div>

          <div className="content-section">
            <h3>Titolare del Trattamento</h3>
            <p>
              Titolare del trattamento, ai sensi dell'art. 4 del Codice e del GDPR, è COM Service S.c.a.r.l, - Via Isonzo 6 – 22078
              Turate (CO) -<a href="mailto:info@com-service.biz">info@com-service.biz</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelezionePersonale;
